import { render, staticRenderFns } from "./MedicationAdministrationRep.vue?vue&type=template&id=a2583030&"
import script from "./MedicationAdministrationRep.vue?vue&type=script&lang=js&"
export * from "./MedicationAdministrationRep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports